import { useIsMobileShell } from '@/shared/lib/useIsMobileShell';

import { useRole } from '@/entities/user';

import { useReportProblem } from '@/features/report-problem';

import { useMobileNav } from '../model/useMobileNav';
import { MobileNavDrawer } from './MobileNavDrawer';
import { MobileTopBar } from './MobileTopBar';
import { Sidebar } from './Sidebar';

/** Задержка перед снятием скрина на мобиле: ждём анимацию закрытия Drawer */
const DRAWER_CLOSE_DELAY_MS = 400;

/** Ждём схлопывания рельсы (transition width 0.5s) перед снятием скрина */
const SIDEBAR_COLLAPSE_DELAY_MS = 550;

/**
 * Навигация приложения: рельса на десктопе, AppBar + Drawer на мобиле/планшете.
 * Владеет модалкой «Сообщить о проблеме» — она общая для обеих раскладок.
 */
export const Navigation = () => {
  const isMobile = useIsMobileShell();
  const role = useRole();
  const { isOpen, open, close } = useMobileNav();
  const { openReportProblem, reportProblemModal } = useReportProblem();

  /** Закрыть Drawer и снять скрин уже без него в кадре */
  const handleMobileReportProblem = () => {
    close();
    openReportProblem({ delayMs: DRAWER_CLOSE_DELAY_MS });
  };

  if (!isMobile) {
    return (
      <>
        <Sidebar
          onReportProblem={() =>
            openReportProblem({ delayMs: SIDEBAR_COLLAPSE_DELAY_MS })
          }
        />
        {reportProblemModal}
      </>
    );
  }

  return (
    <>
      <MobileTopBar onMenuClick={open} role={role} />
      <MobileNavDrawer
        open={isOpen}
        onClose={close}
        role={role}
        onReportProblem={handleMobileReportProblem}
      />
      {reportProblemModal}
    </>
  );
};
